// extracted by mini-css-extract-plugin
export var lg = "_jf-7";
export var md = "_jf-6";
export var placeholderContainer = "_jf-1";
export var placeholderIcon = "_jf-2";
export var productImage = "_jf-0";
export var sm = "_jf-5";
export var xl = "_jf-8";
export var xs = "_jf-4";
export var xxs = "_jf-3";